import React, { useEffect, useState } from 'react';
import { Box, Button, Tooltip, Typography } from '@mui/material';
import { apiConstants, postGeneric } from './constants';
import withLayout from '../hocs/Layout';
import PageTitle from './PageTitle';
import ProzoDataGrid from './ProzoDataGrid';
import Loader from '../common/Loader';
import { formatDate } from '../helpers/UtilityHelper';
import { pageContainerSx } from '../styles/patterns';
import { primaryTextSx, secondaryTextSx, cellStackSx } from '../components/orders/list2/cellStyles';

const PushNotificationList = () => {
    const [allNotification, setAllNotification] = useState([]);
    const [loading, setLoading] = useState(true);
    const [page, setPage] = useState(0);
    const [sizePerPage, setSizePerPage] = useState(10);

    useEffect(() => {
        setLoading(true)
        postGeneric(`${apiConstants.GET_NOTIFICATIONS}`, {
            "andfilter": [{
                field: "active",
                operator: "eq",
                value: true,
            }],
            "limit": 50
        })
            .then((res) => {
                const notifications = res?.data?.data.filter((val) => val.destination === "PUSH");
                setAllNotification(notifications);
            })
            .catch((err) => {
                console.error(err);
            })
            .finally(() => {
                setLoading(false);
            });
    }, []);

    const columns = [
        {
            field: 'header',
            headerName: 'Header',
            flex: 0.8,
            minWidth: 160,
            renderCell: (params) => (
                <Box sx={cellStackSx}>
                    <Typography sx={primaryTextSx}>{params.value}</Typography>
                </Box>
            )
        },
        {
            field: 'text',
            headerName: 'Message',
            flex: 2,
            minWidth: 300,
            renderCell: (params) => (
                <Box sx={cellStackSx}>
                    <Typography sx={secondaryTextSx}>{params.value}</Typography>
                </Box>
            )
        },
        {
            field: 'createdDate',
            headerName: 'Date',
            flex: 0.5,
            minWidth: 120,
            renderCell: (params) => (
                <Box sx={cellStackSx}>
                    <Typography sx={secondaryTextSx}>
                        {formatDate(params.value, 'dd MMM, yyyy')}
                    </Typography>
                </Box>
            )
        },
        {
            field: 'view',
            headerName: 'Action',
            flex: 0.4,
            minWidth: 80,
            sortable: false,
            renderCell: (params) => (
                <Box sx={cellStackSx}>
                    {params.row.text1 && params.row.description ? (
                        <Tooltip title={params.row.text1} arrow>
                            <Button
                                variant="text"
                                size="small"
                                onClick={() => window.open(params.row.description, '_blank')}
                                sx={{ fontSize: '12px', textTransform: 'none', p: 0, minWidth: 'auto' }}
                            >
                                View
                            </Button>
                        </Tooltip>
                    ) : null}
                </Box>
            )
        }
    ];

    return (
        <Box sx={pageContainerSx}>
            {loading && <Loader />}
            <PageTitle subTitle="System notifications and operational updates for your account">Operations Alerts</PageTitle>
            <ProzoDataGrid
                columns={columns}
                autoHeight={true}
                rows={allNotification}
                sizePerPage={sizePerPage}
                setSizePerPage={setSizePerPage}
                setPage={setPage}
                page={page}
                pagination={true}
                paginationMode={'client'}
                rowCount={allNotification?.length}
                getRowId={(row) => row.id}
            />
        </Box>
    );
};

export default withLayout(PushNotificationList);
